// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1sUlv","legacyBtn":"MutateMid_legacyBtn__vmkeF"};